(function () {
  function winLoseController (data) {
    return {
      data: data,
      
      init: function () {
        $('main').on('click', '.index-link', function (e) {
          mem.showPage('index');
          return false;
        });
      }
    }
  }

  mem.page('win', winLoseController);
  mem.page('lose', winLoseController);
})();
